import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles/global.css";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { config } from "./config";
import "./earth/mapMode";
import { AuthProvider } from "./contexts/AuthContext";
import { CartProvider } from "./contexts/CartContext";
import { WorldMapProvider } from "./contexts/WorldMapContext";
import { LocaleProvider } from "./contexts/LocaleContext";
import { ToastProvider } from "./contexts/ToastContext";
import { ConsentProvider } from "./contexts/ConsentContext";
import { AppRouter } from "./router";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root not found");

createRoot(rootEl).render(
  <StrictMode>
    <GoogleOAuthProvider clientId={config.googleClientId}>
      <LocaleProvider>
        <ConsentProvider>
          <ToastProvider>
            <AuthProvider>
              <CartProvider>
                <WorldMapProvider>
                  <AppRouter />
                </WorldMapProvider>
              </CartProvider>
            </AuthProvider>
          </ToastProvider>
        </ConsentProvider>
      </LocaleProvider>
    </GoogleOAuthProvider>
  </StrictMode>,
);
